import * as Yup from 'yup';
import { IntlShape } from "react-intl";
import { interventionValidationResourseUsagePartV2 } from './interventionValidationSchemaGeneralPart';

const assembleValidationSchemaSustellBeef = (
  baseSchema: any,
  confObj: { intl: IntlShape; userUOM?: any; }
) => {
  const infoObject = baseSchema;
  const combinedSchema = Yup.object({ info: infoObject })
    .concat(Yup.object({ resourceUse: interventionValidationResourseUsagePartV2(confObj) }));

  return combinedSchema;
};

export default assembleValidationSchemaSustellBeef;